import { track } from '../utils/tracking';

class FaqItem extends HTMLElement {
  constructor() {
    super();

    // Open status
    this.open = this.dataset.open === 'true';

    // Setup elements
    this.toggle = this.querySelector('[data-toggle]');
    this.content = this.querySelector('[data-content]');
    this.closeIcon = this.querySelector('[data-close-icon]');

    // Bind event handlers
    this.toggle.addEventListener('click', this.handleToggle.bind(this));
    this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
    this.addEventListener('shopify:block:deselect', this.handleBlockDeselect.bind(this));
  }

  handleToggle() {
    this.open = !this.open;
    this.updateVisibility();

    track(`faq_item_${this.open ? 'open' : 'close'}`);
  }

  handleBlockSelect() {
    this.open = true;
    this.updateVisibility();
  }

  handleBlockDeselect() {
    this.open = false;
    this.updateVisibility();
  }

  updateVisibility() {
    this.content.classList.toggle('max-h-0', !this.open);
    this.content.classList.toggle('max-h-96', this.open);
    this.closeIcon.classList.toggle('rotate-45', !this.open);
  }
}

customElements.define('faq-item', FaqItem);
